/**
 * Get Kiosk Settings Use Case
 * Business logic for fetching kiosk settings
 */

import { KioskSettingsRepository } from '../data/kiosk-settings-repository';
import { KioskSettingsDto } from '../types/kiosk-settings-types';

/**
 * Use case for fetching kiosk settings
 * Encapsulates business logic and validation
 */
export class GetKioskSettingsUseCase {
  constructor(private repository: KioskSettingsRepository) {}

  /**
   * Execute: Fetch kiosk settings for an operator
   * @param operatorId - The operator ID to fetch settings for
   * @returns Promise with KioskSettingsDto
   * @throws Error if operatorId is invalid or API call fails
   */
  async execute(operatorId: number): Promise<KioskSettingsDto> {
    // Validate input
    if (!operatorId || operatorId <= 0) {
      throw new Error('Invalid operator ID: must be a positive number');
    }

    try {
      const settings = await this.repository.getSettings(operatorId);

      return settings;
    } catch (error) {
      throw error;
    }
  }
}
